import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    capitalize,
    combineClasses,
} from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './SvgIcon.scss';

function SvgIcon(props) {
    const {
        children,
        classes: classesProp = {},
        className,
        color = 'inherit',
        component: Component = 'svg',
        componentProps,
        fontSize = 'default',
        titleAccess,
        viewBox = '0 0 24 24',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <Component
            aria-hidden={titleAccess
                ? undefined
                : true}
            className={clsx(
                classes.root,
                {
                    [classes[`color${capitalize(color)}`]]: color !== 'inherit',
                    [classes[`fontSize${capitalize(fontSize)}`]]: fontSize !== 'default',
                },
                className,
            )}
            focusable="false"
            role={titleAccess
                ? 'img'
                : undefined}
            viewBox={viewBox}
            {...otherProps}
            {...componentProps}
        >
            {children}
            {titleAccess
                ? <title>{titleAccess}</title>
                : null}
        </Component>
    );
}

SvgIcon.propTypes = {
    /**
     * The content of the component.
     */
    children: PropTypes.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * The color of the component.
     */
    color: PropTypes.oneOf([
        'initial',
        'inherit',
        'primary',
        'secondary',
        'error',
    ]),
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    /**
     * The fontSize applied to the icon. Defaults to 24px.
     */
    fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),
    /**
     * Provides a human-readable title for the element that contains it for semantic icons
     * https://www.w3.org/TR/SVG-access/#Equivalent
     */
    titleAccess: PropTypes.string,
    /**
     * Allows you to redefine what the coordinates without units mean inside an SVG element.
     * For example, if the SVG element is 500 (width) by 200 (height),
     * and you pass viewBox="0 0 50 20",
     * this means that the coordinates inside the SVG will go from the top left corner (0,0)
     * to bottom right (50,20) and each unit will be worth 10px.
     */
    viewBox: PropTypes.string,

};

export default SvgIcon;
